import { CurrencyPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PaymentFrequency } from '../../../shared/enums/payment-frequency';
import { PaymentSuffixPipe } from '../../../shared/pipes/payment-suffix.pipe';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-total',
    standalone: true,
    imports: [
        CurrencyPipe,
        NgIf,
        PaymentSuffixPipe,
    ],
    templateUrl: './total.component.html',
    styleUrl: './total.component.scss',
})
export class TotalComponent {
    @Input() public freq: PaymentFrequency | undefined;

    @Input({ required: true }) public quantity!: number;

    @Input({ required: true }) public total!: number;

    @Input() public totalDiscount?: number;

    @Input() public totalRaw?: number;
}
